import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'features/app/store/store';
import { isSamePhoneNumber } from 'features/call/call-base/helpers';
import {
  deafPhoneNumberSelector,
  deafStatusSelector,
} from 'features/call/call-deaf/store';
import {
  primaryHearingPhoneNumberSelector,
  primaryHearingStatusSelector,
} from 'features/call/call-hearing/store';

export const callInitiatorSelector = ({ call }: RootState) =>
  call.isDeafToHearing ? 'deaf' : 'hearing';

export const callInitiatorPhoneNumberSelector = (state: RootState) =>
  callInitiatorSelector(state) === 'deaf'
    ? deafPhoneNumberSelector(state)
    : primaryHearingPhoneNumberSelector(state);

export const isCallInitiatorPhoneNumberSelector = createSelector(
  callInitiatorPhoneNumberSelector,
  (initiatorPhoneNumber) => (phoneNumber: string) =>
    isSamePhoneNumber(phoneNumber, initiatorPhoneNumber)
);

export const isOnlyCallInitiatorConnectedSelector = (state: RootState) =>
  createSelector(
    callInitiatorSelector,
    primaryHearingStatusSelector,
    deafStatusSelector,
    (callInitiator, hearingStatus, deafStatus) => {
      return (
        (callInitiator === 'hearing' &&
          deafStatus === 'disconnected' &&
          hearingStatus === 'connected') ||
        (callInitiator === 'deaf' &&
          deafStatus === 'connected' &&
          hearingStatus === 'disconnected')
      );
    }
  )(state);

export const isCallReceiverDisconnectedSelector = (state: RootState) =>
  createSelector(
    callInitiatorSelector,
    primaryHearingStatusSelector,
    deafStatusSelector,
    (callInitiator, hearingStatus, deafStatus) => {
      return (
        (callInitiator === 'hearing' && deafStatus === 'disconnected') ||
        (callInitiator === 'deaf' && hearingStatus === 'disconnected')
      );
    }
  )(state);
